import { Radius as BaseRadius } from './Border';
import * as BaseSizes from './Size';

export enum Spacing {
  Medium = 10,
}

export const Border = {
  Size: {
    Small: BaseSizes.X3Small,
  },
};

export enum Radius {
  XSmall = BaseRadius.XSmall,
  Small = BaseRadius.Medium,
  Medium = BaseRadius.XLarge,
  LargeMedium = BaseRadius.Large,
  Large = BaseRadius.XLarge,
}

export const Size = {
  Inline: {
    width: 140,
    height: BaseSizes.X8Large,
  },
  Full: {
    width: 288,
    height: BaseSizes.X8Large,
  },
};
